import React from 'react';
import { FaCalendarAlt, FaUsers, FaTrophy, FaMedal, FaTrophy as FaTrophyAlt, FaUsers as FaUsersAlt, FaBullseye, FaHeart, FaMapMarkerAlt, FaAward, FaBookOpen, FaFilm } from 'react-icons/fa';
import './Clube.css';

const Clube = () => {
  return (
    <div className="clube-page">
      <section className="page-header-clube">
        <div className="container">
          <h1>Sobre o Clube</h1>
          <p>Mais de 80 anos de tradição desportiva na Póvoa, formando atletas de elite e construindo uma comunidade inabalável.</p>
        </div>
      </section>

      <section className="historia-section">
        <div className="container">
          <div className="historia-grid">
            <div className="historia-text">
              <h2>A Nossa História</h2>
              <p>
                O Clube Desportivo Da Póvoa foi fundado em 1943 com o objetivo de promover o desporto e os valores de fair play na comunidade local.
                Desde então, temos sido o pilar fundamental no desenvolvimento desportivo da região.
              </p>
              <p>
                Ao longo de oito décadas, formámos milhares de atletas, conquistámos títulos nacionais e, acima de tudo,
                criámos uma família unida pela paixão e pelo orgulho poveiro.
              </p>
              <p>
                Hoje, o clube conta com instalações de excelência, equipas competitivas em 8 modalidades e programas de formação referência a nível nacional.
              </p>
            </div>

            <div className="historia-stats-grid">
              <div className="stat-box">
                <FaCalendarAlt className="stat-icon" />
                <h3>80+</h3>
                <p>Anos de Glória</p>
              </div>
              <div className="stat-box">
                <FaUsers className="stat-icon" />
                <h3>600+</h3>
                <p>Atletas Ativos</p>
              </div>
              <div className="stat-box">
                <FaTrophy className="stat-icon" />
                <h3>8</h3>
                <p>Modalidades</p>
              </div>
              <div className="stat-box">
                <FaMedal className="stat-icon" />
                <h3>25+</h3>
                <p>Títulos Nacionais</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="valores-section">
        <div className="container">
          <div className="section-title-center">
            <span className="section-subtitle">DNA CDP</span>
            <h2>Os Nossos Valores</h2>
            <p>Princípios inegociáveis que guiam cada decisão e ação no nosso clube.</p>
          </div>

          <div className="valores-grid">
            <div className="valor-card">
              <div className="valor-icon-box">
                <FaTrophyAlt />
              </div>
              <h3>Excelência</h3>
              <p>Comprometidos com a formação de atletas de alto nível e resultados desportivos que orgulham a cidade.</p>
            </div>

            <div className="valor-card">
              <div className="valor-icon-box">
                <FaUsersAlt />
              </div>
              <h3>Comunidade</h3>
              <p>Unidos pela paixão pelo desporto, construímos uma família forte, diversa e acolhedora.</p>
            </div>

            <div className="valor-card">
              <div className="valor-icon-box">
                <FaBullseye />
              </div>
              <h3>Formação</h3>
              <p>Dedicados ao desenvolvimento integral de jovens atletas, focando em valores, disciplina e caráter.</p>
            </div>

            <div className="valor-card">
              <div className="valor-icon-box">
                <FaHeart />
              </div>
              <h3>Paixão</h3>
              <p>Movidos pelo amor incondicional ao desporto e pelo orgulho imenso de representar a Póvoa de Varzim.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="timeline-section">
        <div className="container">
          <div className="section-title-center">
            <span className="section-subtitle">A Nossa Jornada</span>
            <h2>Marcos Históricos</h2>
            <p>Os momentos fundamentais que definiram a trajetória do clube ao longo das décadas.</p>
          </div>

          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-content-left">
                <h3>A fundação do Clube</h3>
                <p>O Clube Desportivo (CD) da Póvoa é uma instituição sem fins lucrativos fundada em 26 de dezembro de 1943. A história da sua criação remonta a uma tarde de domingo, na qual um grupo de jovens, reunidos depois de um jogo de futebol, decide agitar a atividade desportiva do concelho devolvendo aos poveiros o desporto-rei, fundando um grupo de futebol. Por mais arriscada que a ideia pudesse parecer, o certo é que foi levada adiante e, sob o lema “Ao Serviço do Desporto, da Cultura e da Póvoa”, nasceu o Clube Desportivo da Póvoa.</p>
              </div>
              <div className="timeline-date">1943</div>
              <div className="timeline-content-right"></div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left"></div>
              <div className="timeline-date">1944</div>
              <div className="timeline-content-right">
                <h3>O primeiro troféu</h3>
                <p>O grupo de futebol do CD Póvoa inscreveu-se, em 1944, na Associação de Futebol do Porto e alcançou vários momentos de glória. Nesse ano, a “Taça Eça de Queirós” foi conquistada num torneio realizado na Póvoa, constituindo o seu primeiro troféu.</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left">
                <h3>Os "Onze dos Júniores"</h3>
                <p>Nos anos de 1945, 1947 e 1948, o grupo de futebol do CD Póvoa assumiu-se como vencedor de série e finalista, conservando ao longo do seu percurso o “onze dos juniores”. Para além das competições oficiais, era constantemente convidado para encontros particulares um pouco por toda a região Norte do país. No entanto, com o passar dos anos e por motivos alheios à vontade dos seus responsáveis, o CD Póvoa viu-se obrigado a abandonar o futebol. Em contrapartida, abriu as portas a novas modalidades. A divisa “Ao Serviço do Desporto, da Cultura e da Póvoa” fazia, agora, ainda mais sentido.</p>
              </div>
              <div className="timeline-date">1945</div>
              <div className="timeline-content-right"></div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left"></div>
              <div className="timeline-date">1947</div>
              <div className="timeline-content-right">
                <h3>O arranque do Voleibol</h3>
                <p>Criada a secção de voleibol, a 6 de março de 1947, foi com uma equipa de seniores masculinos que o CD Póvoa participou, pela primeira vez, numa prova oficial, designadamente no Campeonato Regional da II Divisão.</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left">
                <h3>Nasce o Hóquei em Patins</h3>
                <p>A primeira equipa de hóquei em patins do CD Póvoa surgiu em 1950, altura em que o clube já dispunha de um parque desportivo que incluía um rinque de patinagem com as medidas legais para a prática da modalidade. A sua apresentação aconteceu na tarde do dia 10 de dezembro, num jogo contra a seleção de Braga, que terminou com uma derrota por 1-17. Um resultado que refletia a inexperiência do clube poveiro.</p>
              </div>
              <div className="timeline-date">1950</div>
              <div className="timeline-content-right"></div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left"></div>
              <div className="timeline-date">1965</div>
              <div className="timeline-content-right">
                <h3>As Bodas de Prata</h3>
                <p>Mas não foi só à base de resultados desportivos que o sucesso do CD Póvoa foi atingido. A construção do pavilhão gimnodesportivo, inaugurado nas suas Bodas de Prata, assim como das piscinas, dos courts de ténis e do parque de campismo funcionou igualmente como um forte estímulo para a continuação do trabalho desenvolvido até então. Num curto período de tempo, o CD Póvoa tornou-se num dos clubes mais ecléticos do país e numa das associações desportivas mais importantes da nossa região.</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left">
                <h3>O Boom das modalidades</h3>
                <p>Andebol, ciclismo, automobilismo, bilhar, ginástica, ballet, natação, ténis de mesa, patinagem artística, pesca desportiva, ténis, judo, damas e xadrez, constituíram o vasto e diversificado leque de modalidades desportivas que o CD Póvoa colocou à disposição da juventude poveira e nas quais foram alcançados alguns feitos meritórios.</p>
              </div>
              <div className="timeline-date">1968</div>
              <div className="timeline-content-right"></div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left"></div>
              <div className="timeline-date">1970</div>
              <div className="timeline-content-right">
                <h3>A pesca desportiva</h3>
                <p>A Pesca Desportiva foi, sem dúvida, a que mais vezes elevou o nome do Clube com a conquista de vários títulos nacionais e regionais, com maior incidência nas décadas de 70 e 80.</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left">
                <h3>A Primeira Equipa de Basquetebol</h3>
                <p>A primeira equipa de basquetebol surge in 1971. Neste ano, foi inscrita a equipa de juvenis na AB Porto, liderada por Armando José Queirós Frias, que aceitou o desafio de criar a secção de basquetebol no clube. Era um homem com uma visão da juventude e desporto muito avançada para a época.</p>
              </div>
              <div className="timeline-date">1971</div>
              <div className="timeline-content-right"></div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left"></div>
              <div className="timeline-date">1984</div>
              <div className="timeline-content-right">
                <h3>A Secção de Damas</h3>
                <p>A secção de damas, uma modalidade já extinta no clube, foi a primeira modalidade a sagrar-se campeã a nível nacional, na época 1984/85.</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left">
                <h3>O palmarés invejável</h3>
                <p>A secção de basquetebol, após uma década de trabalho sustentável nos escalões femininos, contribuiu brilhantemente para o invejável palmarés que, atualmente, o CD Póvoa possui: conquistou o título de Campeão Nacional da Liga Feminina de Basquetebol, na época 1999/00.</p>
              </div>
              <div className="timeline-date">1999</div>
              <div className="timeline-content-right"></div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left"></div>
              <div className="timeline-date">2000</div>
              <div className="timeline-content-right">
                <h3>Títulos no Atletismo e Voleibol</h3>
                <p>Foi uma mudança de século recheada de sucessos, com a subida à Divisão A2 dos seniores masculinos de voleibol, na época 2000/01, acompanhada do título de Campeões Nacionais da II Divisão. A secção de atletismo também brindou o clube com vários títulos nacionais individuais e, por duas vezes, com o título de Campeão Nacional da II Divisão Feminina, nas épocas 1999/00 e 2000/01.</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left">
                <h3>Hóquei no Primeiro Escalão</h3>
                <p>Um momento histórico na vida do clube. Graças a um excelente campeonato, que terminou com a conquista do título da II divisão/zona Norte, o CD Póvoa assegurou a subida ao principal escalão do hóquei em patins. O objetivo foi matematicamente alcançado a 3 de Maio de 2014, quando faltavam duas jornadas para o fim da prova.</p>
              </div>
              <div className="timeline-date">2014</div>
              <div className="timeline-content-right"></div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left"></div>
              <div className="timeline-date">2021</div>
              <div className="timeline-content-right">
                <h3>Subida à Liga de Basquetebol</h3>
                <p>Mais um momento histórico para o CD Póvoa, com a equipa sénior masculina a sagrar-se campeã nacional da Proliga e, pela primeira vez, a marcar presença ao mais alto nível na Liga Portuguesa de Basquetebol.</p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content-left">
                <h3>Hoje</h3>
                <p>Mantendo a jovialidade dos tempos da fundação, um ecletismo invulgar e uma assinalável capacidade de atração de novos atletas, o CD Póvoa está confiante no futuro. Graças à relação que foi criando com a comunidade, tem conseguido manter ativa a sua rede de formação, moldada pelos mais nobres valores, o que nos faz acreditar num futuro cada vez mais auspicioso.</p>
              </div>
              <div className="timeline-date">2022</div>
              <div className="timeline-content-right"></div>
            </div>
          </div>
        </div>
      </section>

      <section className="curiosidades-section">
        <div className="container">
          <div className="section-title-center">
            <span className="section-subtitle">O Legado CDP</span>
            <h2>Curiosidades Históricas</h2>
            <p>Os marcos e iniciativas que enriquecem a memória e a alma do nosso clube.</p>
          </div>

          <div className="curiosidades-grid">
            <div className="curiosidade-card">
              <div className="curiosidade-icon-box">
                <FaAward />
              </div>
              <h3>Distinções de Prestígio</h3>
              <p>
                Sob a divisa <strong>“Ao Serviço do Desporto, da Cultura e da Póvoa”</strong>, o CD Póvoa recebeu vários gestos honorificativos:
              </p>
              <ul className="curiosidades-list">
                <li>
                  <span className="curiosidade-bullet-date">14 Dez 1969</span>
                  <span><strong>Medalha de Reconhecimento Poveiro</strong>, atribuída pela Câmara Municipal da Póvoa de Varzim.</span>
                </li>
                <li>
                  <span className="curiosidade-bullet-date">Nacional</span>
                  <span><strong>Medalha de Serviços Distintos</strong>, atribuída pelo Ministério da Educação Nacional, em apreço pelos serviços prestados ao desporto.</span>
                </li>
                <li>
                  <span className="curiosidade-bullet-date">1999</span>
                  <span><strong>Medalha de Ouro de Reconhecimento Poveiro</strong>, reforçando o seu papel central na comunidade.</span>
                </li>
              </ul>
            </div>

            <div className="curiosidade-card">
              <div className="curiosidade-icon-box">
                <FaBookOpen />
              </div>
              <h3>Dinâmica Cultural (1943-1958)</h3>
              <p>
                O CD Póvoa sempre foi mais do que desporto, tendo uma forte veia artística e intelectual até à extinção da sua secção cultural em 1958:
              </p>
              <ul className="curiosidades-list">
                <li>
                  <strong>Cineclube e Biblioteca Associativa:</strong> Criação de espaços associativos fundamentais de acesso à cultura e cinema.
                </li>
                <li>
                  <strong>Saraus, Recitais e Jogos Florais:</strong> Realização de Saraus, Recitais de Poesia e organização de Jogos Florais.
                </li>
                <li>
                  <strong>Festivais de Folclore:</strong> Organização de Festivais Nacionais e Internacionais de Folclore poveiro.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="instalacoes-section">
        <div className="container">
          <div className="instalacoes-icon">
            <FaMapMarkerAlt />
          </div>
          <div className="section-title-center white-text">
            <h2 className="gold-title">Infraestruturas de Elite</h2>
            <p>Um complexo desportivo moderno, preparado para o alto rendimento e para a comunidade.</p>
          </div>

          <div className="instalacoes-grid">
            <div className="instalacao-card">
              <h3>Pavilhão Fernando Linhares de Castro</h3>
              <p>O coração do clube. Pavilhão polivalente com capacidade para 600 espetadores, palco de grandes batalhas no Basquetebol, Voleibol e Hóquei.</p>
            </div>

            <div className="instalacao-card">
              <h3>Piscina Exterior de Água Salgada</h3>
              <p>A atração de verão da cidade. Complexo exterior de água salgada captada diretamente do mar da Póvoa (temperatura sempre convidativa), resguardado das nortadas e totalmente renovado. Dispõe de piscina de adultos (35m x 15m, prof. 1,30m a 2,15m), piscina redonda para crianças (diâmetro 10m, prof. 0,75m), espreguiçadeiras, colchões, serviço de bar e balneários dedicados.</p>
            </div>

            <div className="instalacao-card">
              <h3>Sede Social e Auditório</h3>
              <p>O centro administrativo e cultural. Espaço moderno para conferências, sala de troféus histórica e áreas de convívio para sócios.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Clube;